module.exports = __webpack_public_path__ + "fonts/Canaro-Bold.15cb1e9e.woff2";